import dayjs from 'dayjs'
import {
    NivelPontoDiario,
    LinhaGranularPontoDiario,
} from './niveis-agrupamento'

export interface LinhaExplodida extends Omit<LinhaGranularPontoDiario, 'id'> {
    id: string
    _centroCustoNome: string
    _localNome: string
    _funcionarioNome: string
    _diaLabel: string
}

/**
 * Explode cada linha granular no produto cartesiano de Centro de Custo × Local
 * — mas SÓ nas dimensões que estão em `niveisAtivos`. Dimensão não marcada usa
 * só o primeiro vínculo como rótulo, sem duplicar linha por ela (evita
 * combinatória desnecessária quando o nível não é usado pra agrupar).
 *
 * Fan-out é a mesma regra de `agruparHierarquico` (backend/libs/common), só
 * que materializada como linhas físicas em vez de árvore — necessário porque
 * o agrupamento nativo do TanStack espera 1 valor escalar por linha por
 * coluna de agrupamento, não múltiplos vínculos por linha.
 */
export function explodirLinhas(
    linhas: LinhaGranularPontoDiario[],
    niveisAtivos: Set<NivelPontoDiario>,
): LinhaExplodida[] {
    return linhas.flatMap(linha => {
        const centros = niveisAtivos.has('centroCusto')
            ? linha.CentrosCusto
            : linha.CentrosCusto.slice(0, 1)
        const locais = niveisAtivos.has('local')
            ? linha.Locais
            : linha.Locais.slice(0, 1)

        return centros.flatMap(cc =>
            locais.map(local => ({
                ...linha,
                id: `${linha.id}/cc-${cc.id}/local-${local.id}`,
                _centroCustoNome: cc.nomeCentroCusto,
                _localNome: local.nomeLocal,
                _funcionarioNome: linha.Funcionario.nome,
                _diaLabel: dayjs.utc(linha.data).format('DD/MM/YYYY'),
            })),
        )
    })
}
